module.exports = __webpack_public_path__ + "static/media/loader.d43ea3d9.svg";